
import { CartItem } from "@/types/cart";
import { toast } from "@/hooks/use-toast";

interface OrderData {
  customerName: string;
  customerPhone: string;
  deliveryAddress: string;
  paymentMethod: string;
  cart: CartItem[];
  totalPrice: number;
  needChange?: boolean;
  changeAmount?: string;
  sodaFlavor?: string;
  cardType?: string;
  selectedExtras?: string[];
  isLoggedIn?: boolean;
  isFirstPurchase?: boolean;
}

const WHATSAPP_NUMBER = "5132422047";


export const processWhatsAppOrder = (orderData: OrderData): void => {
  const { 
    customerName, 
    customerPhone, 
    deliveryAddress, 
    paymentMethod, 
    cart, 
    totalPrice,
    needChange,
    changeAmount,
    sodaFlavor,
    cardType,
    isLoggedIn = false,
    isFirstPurchase = false
  } = orderData;
  
  
  // Format cart items for WhatsApp including extras
  const orderItems = cart.map(item => {
    let itemText = `${item.quantity}x ${item.product.name} - R$${(item.product.price * item.quantity).toFixed(2)}`;
    
    // Add customizations
    if (Array.isArray(item.customizations) && item.customizations.length > 0) {
      item.customizations.forEach(customization => {
        itemText += `\n   ${customization.type === 'adicionar' ? '+' : '-'} ${customization.description}`;
        if (customization.price > 0) {
          itemText += ` (+R$${(customization.price * item.quantity).toFixed(2)})`;
        }
      });
    }
    
    // Add extras
    if (Array.isArray(item.extras) && item.extras.length > 0) {
      item.extras.forEach(extra => {
        itemText += `\n   + ${extra.name} (+R$${(extra.price * item.quantity).toFixed(2)})`;
      });
    }
    
    // Add notes
    if (item.notes) {
      itemText += `\n   Obs: ${item.notes}`;
    }
    
    return itemText;
  }).join('\n\n');
  
  // Create WhatsApp message
  let message = `*Pedido *\n\n`;
  message += `*Cliente:* ${customerName}\n`;
  message += `*Telefone:* ${customerPhone}\n`;
  message += `*Endereço:* ${deliveryAddress}\n`;
  
  // Format payment method with card type if applicable
  let paymentText = paymentMethod === 'dinheiro' ? 'Dinheiro' : (paymentMethod === 'cartao' ? 'Cartão' : 'PIX');
  if (paymentMethod === 'cartao' && cardType) {
    paymentText += ` (${cardType})`;
  }
  message += `*Forma de Pagamento:* ${paymentText}\n`;
  
  // Add change information if needed
  if (paymentMethod === 'dinheiro' && needChange && changeAmount) {
    message += `*Troco para:* R$${changeAmount}\n`;
  }
  
  message += `\n*Itens do pedido:*\n${orderItems}\n`;
  
  message += `\n*Total:* R$${totalPrice.toFixed(2)}`;
  
  // Add soda flavor information if specified by a registered user on first purchase
  if (isLoggedIn && isFirstPurchase && sodaFlavor) {
    message += `\n\n*Mini Refrigerante (Grátis na primeira compra):* ${sodaFlavor}`;
  }
  
  // Encode message for URL
  const encodedMessage = encodeURIComponent(message);
  
  // Create WhatsApp URL
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
  
  // Notify user
  toast({
    title: "Pedido Enviado!",
    description: "Seu pedido está sendo enviado via WhatsApp",
  });

  // Open WhatsApp in new tab
  window.open(whatsappUrl, '_blank');
};
